import { h } from 'preact';
import EditingBtns from './EditingBtns';
import { Link } from 'react-router-dom';
const Address = ({ address, city, state, zip }) => {
    if (address && city && state && zip) {
        return (h("address", null,
            address,
            h("br", null),
            city,
            ", ",
            state.toUpperCase(),
            ". ",
            zip));
    }
    else {
        return null;
    }
};
const Customer = ({ customer, displayChooseOption = false, handleOption, isEditable, handleEdit, handleDelete, showLink = true }) => h("div", { className: "invoice__row row customer" },
    h("div", { className: "col-md-8" },
        showLink ? h(Link, { className: "takeover-link", to: `/customer/${customer._id}` }) : null,
        h("div", { className: "name" },
            customer.name.first,
            " ",
            customer.name.last),
        h("div", null, customer.email),
        h("div", null, customer.phone),
        h(Address, { ...customer })),
    h("div", { className: "col-md-4" },
        isEditable &&
            h("div", { className: "row" },
                h(EditingBtns, { data: customer, handleEdit: handleEdit, handleDelete: handleDelete })),
        displayChooseOption &&
            h("button", { onClick: () => {
                    handleOption(user);
                } }, "Choose")));
export default Customer;
